(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jwa-about"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (scope) => {
    scope.querySelectorAll('.ja-series-gallery').forEach(gallery => {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = 'true';
      const track = gallery.querySelector('.ja-series-track');
      const controls = gallery.querySelector('.ja-series-controls');
      const prev = controls.querySelector('[data-ja-prev]');
      const next = controls.querySelector('[data-ja-next]');
      const sync = () => {
        const max = track.scrollWidth - track.clientWidth;
        controls.hidden = max <= 2;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max - 2;
      };
      const move = (direction) => {
        const card = track.querySelector('.ja-series-card');
        if (!card) return;
        track.scrollBy({left: direction * (card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap)), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      prev.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('scroll', sync, {passive:true});
      track.addEventListener('keydown', event => {
        if (event.target !== track || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
        event.preventDefault();move(event.key === 'ArrowRight' ? 1 : -1);
      });
      const observer = new ResizeObserver(sync);observer.observe(track);sync();
      document.addEventListener('shopify:section:unload', event => {if(event.target.contains(gallery)) observer.disconnect();});
    });
  };
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), {once:true}); else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jwa-contact"] && !Shopify.designMode) return;
  try {
    
(() => {
  const css = `
    [data-jct-form]{display:grid!important;grid-template-columns:minmax(0,1fr) minmax(0,1fr);gap:0 16px!important}
    [data-jct-form]>div,[data-jct-form]>button{grid-column:1/-1}
    [data-jct-form]>output{grid-column:1/-1;order:0;color:#a83432;font:600 14px/1.5 Arial,sans-serif;margin-bottom:8px}
    [data-jct-field]{position:relative;min-width:0;margin:0 0 20px!important;display:flex;flex-direction:column}
    [data-jct-field]>label{position:static!important;transform:none!important;font:600 14px/1.6 Arial,sans-serif!important;order:-1;margin:0 0 8px!important;color:#302e2b!important;z-index:1;max-width:none!important;background:transparent!important}
    [data-jct-field]>input,[data-jct-field]>textarea{box-sizing:border-box!important;width:100%;border:1px solid #9b958c!important;box-shadow:none!important;border-radius:5px!important;padding:12px!important;background:#fff!important;color:#302e2b!important;font:16px/1.5 Arial,sans-serif!important;min-height:46px}
    [data-jct-field]>textarea{min-height:150px;resize:vertical}
    [data-jct-field]>:focus-visible{outline:2px solid #52634b;outline-offset:3px}
    [data-jct-kind="first_name"]{grid-column:1!important;order:2}
    [data-jct-kind="email"]{grid-column:2!important;order:2}
    [data-jct-kind="idea"]{order:3}
    [data-jct-field]::before,[data-jct-field]::after{content:none!important;display:none!important}
    [data-jct-kind="optional"]{order:5;grid-column:auto!important}
    [data-jct-form]:not([data-jct-expanded]) [data-jct-kind="optional"]{display:none}
    .jct-project-options{order:1;grid-column:1/-1;border:0;padding:0;margin:24px 0;display:grid;grid-template-columns:1fr 1fr;gap:8px;min-width:0}
    .jct-project-options legend{font:600 14px/1.6 Arial,sans-serif;margin-bottom:10px}
    .jct-project-options label{display:flex;align-items:center;gap:8px;min-height:48px;border:1px solid #d9d2c9;border-radius:5px;padding:10px;font:400 13px/1.5 Arial,sans-serif;cursor:pointer;box-sizing:border-box}
    .jct-project-options label:has(:checked){background:#edf1e8;border-color:#52634b}
    .jct-project-options input{accent-color:#52634b;width:17px;height:17px;flex:none;margin:0}
    .jct-project-options:disabled{opacity:.65}
    [data-jct-select]{order:1;margin:20px 0}
    [data-jct-select][data-jct-proxy]{position:absolute!important;width:1px!important;height:1px!important;overflow:hidden!important;clip-path:inset(50%);pointer-events:none}
    .jct-project-details{order:4;box-sizing:border-box;width:100%;border:0!important;background:#f4f0e9!important;color:#302e2b!important;border-radius:10px!important;padding:14px 16px!important;margin:0 0 24px!important;min-height:64px;display:flex;align-items:center;justify-content:space-between;gap:16px;font:600 14px/1.5 Arial,sans-serif!important;text-align:left;cursor:pointer}
    .jct-project-details:after{content:'';display:block;flex:0 0 32px;width:32px;height:32px;border-radius:50%;background:linear-gradient(currentColor,currentColor) center/14px 2px no-repeat,linear-gradient(currentColor,currentColor) center/2px 14px no-repeat,#fff}
    .jct-project-details[aria-expanded="true"]:after{background-size:14px 2px,2px 0}
    .jct-project-details:hover{background:#ede7dd!important}
    .jct-project-details:focus-visible,[data-jct-form]>button[type="submit"]:focus-visible{outline:2px solid #52634b;outline-offset:3px}
    @media(prefers-reduced-motion:no-preference){.jct-project-details,[data-jct-form]>button[type="submit"]{transition:background-color .18s ease,color .18s ease}}
    [data-jct-upload]{order:6;border:0!important;padding-top:0;margin:0 0 24px}
    [data-jct-upload]>p{font:600 14px/1.6 Arial,sans-serif!important;margin:0 0 8px}
    [data-jct-upload]>div{border:1px dashed #9b958c!important;border-radius:8px!important;background:#fbf9f5!important;box-shadow:none!important;min-height:64px}
    [data-jct-form]>button[type="submit"]{order:7;justify-self:start;box-sizing:border-box;width:max-content!important;max-width:100%!important;min-width:0!important;display:inline-flex!important;align-items:center;justify-content:center;white-space:nowrap!important;text-align:center!important;background:#302e2b!important;color:#fff!important;border:0!important;padding:14px 22px!important;font:600 14px/20px Arial,sans-serif!important;min-height:48px;border-radius:8px!important}
    [data-jct-form]>button[type="submit"]:hover{background:#45423d!important}
    [data-jct-header]{display:none!important}
    @media(max-width:749px){[data-jct-form]{grid-template-columns:minmax(0,1fr)}[data-jct-kind="first_name"],[data-jct-kind="email"],[data-jct-kind="optional"]{grid-column:1!important}[data-jct-form]>button[type="submit"]{width:100%!important}}
    @media(max-width:360px){.jct-project-options{grid-template-columns:1fr}}
  `;
  const hosts = new WeakSet();
  function enhance(host) {
    const root = host.shadowRoot;
    if (!root || hosts.has(host)) return;
    hosts.add(host);
    const style = document.createElement('style');
    style.textContent = css;
    root.append(style);
    const section = host.closest('.jct');
    const en = document.documentElement.lang.startsWith('en');
    const optionalIds = ['custom#dimensions_souhaites','custom#budget_envisag','custom#date_souhaite','custom#ville_ou_organisation'];
    let pending = false;
    function update() {
      const form = root.querySelector('form[data-testid="form"]');
      if (!form) { section.querySelector('.jct-original-intro').hidden = true; return; }
      form.setAttribute('data-jct-form','');
      section.querySelector('.jct-original-intro').hidden = false;
      const header = form.previousElementSibling;
      if (header?.querySelector('h2')) header.setAttribute('data-jct-header','');
      const first = root.getElementById('first_name'), email = root.getElementById('email');
      const idea = form.querySelector('textarea[name="custom#votre_ide"]');
      [[first,'first_name'],[email,'email'],[idea,'idea'],...optionalIds.map(id=>[root.getElementById(id),'optional'])].forEach(([el,kind])=>{
        if(!el)return;
        el.parentElement.setAttribute('data-jct-field','');
        el.parentElement.setAttribute('data-jct-kind',kind);
        if(kind==='idea'){el.id='custom#votre_ide';el.setAttribute('aria-labelledby','label-custom#votre_ide');el.parentElement.setAttribute('data-jct-label',en?'Your idea':'Votre idée');}
      });
      first?.setAttribute('autocomplete','given-name');email?.setAttribute('autocomplete','email');
      const upload = form.querySelector('input[type="file"]');
      upload?.parentElement.parentElement.parentElement.setAttribute('data-jct-upload','');
      if(!form.querySelector('.jct-project-details') && optionalIds.every(id=>root.getElementById(id))){
        const toggle = document.createElement('button');toggle.type='button';toggle.className='jct-project-details';
        toggle.textContent=en?'Add a few details (optional)':'Préciser mon projet (facultatif)';toggle.setAttribute('aria-expanded','false');
        toggle.setAttribute('aria-controls',optionalIds.join(' '));
        toggle.addEventListener('click',()=>{const open=toggle.getAttribute('aria-expanded')!=='true';toggle.setAttribute('aria-expanded',String(open));form.toggleAttribute('data-jct-expanded',open)});
        root.getElementById(optionalIds[0]).parentElement.before(toggle);
      }
      if(!form.dataset.jctInvalidListener){
        form.dataset.jctInvalidListener='true';
        form.addEventListener('invalid',e=>{if(optionalIds.includes(e.target.id)){form.setAttribute('data-jct-expanded','');form.querySelector('.jct-project-details')?.setAttribute('aria-expanded','true')}},true);
      }
      const native = root.getElementById('custom#votre_projet-selector-label')?.parentElement;
      if(!native)return;
      native.setAttribute('data-jct-select','');
      const trigger=native.querySelector('button');
      const values=en?['Oil painting commission','Creative collaboration','Event invitation','Another question']:['Huile sur mesure','Projet de collaboration','Invitation à un événement','Autre question'];
      let fieldset=form.querySelector('.jct-project-options');
      if(!fieldset){
        fieldset=document.createElement('fieldset');fieldset.className='jct-project-options';
        const legend=document.createElement('legend');legend.textContent=en?'What would you like to discuss?':'De quoi souhaitez-vous me parler ?';fieldset.append(legend);
        values.forEach(value=>{const label=document.createElement('label'),radio=document.createElement('input'),span=document.createElement('span');radio.type='radio';radio.name='jct-project';radio.value=value;span.textContent=value;label.append(radio,span);fieldset.append(label);
          radio.addEventListener('change',()=>{
            if(pending)return;pending=true;fieldset.disabled=true;
            if(trigger.getAttribute('aria-expanded')!=='true')trigger.click();
            let attempts=0;
            function select(){const option=[...native.querySelectorAll('[role="option"]')].find(o=>o.textContent.trim()===value);
              if(option){option.click();pending=false;fieldset.disabled=false;radio.focus();update();}
              else if(attempts++<20)setTimeout(select,50);
              else{pending=false;fieldset.disabled=false;native.removeAttribute('data-jct-proxy');native.hidden=false;native.removeAttribute('aria-hidden');trigger.tabIndex=0;fieldset.hidden=true;trigger.focus();}
            }select();
          });
        });form.prepend(fieldset);native.setAttribute('data-jct-proxy','');native.hidden=true;native.setAttribute('aria-hidden','true');trigger.tabIndex=-1;
      }
      if(!pending){const selected=root.getElementById('custom#votre_projet-selector-value')?.textContent.trim();fieldset.querySelectorAll('input').forEach(r=>{r.checked=r.value===selected});}
    }
    const observer=new MutationObserver(()=>{observer.disconnect();update();observer.observe(root,{childList:true,subtree:true});});
    update();observer.observe(root,{childList:true,subtree:true});
  }
  const scan=()=>document.querySelectorAll('.jct-native-form shopify-forms-embed').forEach(enhance);
  scan();const timer=setInterval(scan,300);setTimeout(()=>clearInterval(timer),30000);
  document.addEventListener('shopify:section:load',scan);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jwa-digital-studio-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';

      const header = root.querySelector('[data-jwa-header]');
      const menu = root.querySelector('[data-jwa-menu]');
      const openMenu = root.querySelector('[data-jwa-menu-open]');
      const closeMenu = root.querySelector('[data-jwa-menu-close]');
      const stage = root.querySelector('.jwa-art-stage');
      const cards = [...root.querySelectorAll('.jwa-art-card[href]')];
      const hint = root.querySelector('[data-jwa-hint]');
      const intro = root.querySelector('.jwa-hero__lead');
      const finePointer = matchMedia('(hover:hover) and (pointer:fine)').matches;
      let active = null;
      let pointerStart = null;

      const syncHeader = () => {
        const hero = root.querySelector('.jwa-hero');
        header?.classList.toggle('is-solid', window.scrollY > Math.max(80, (hero?.offsetHeight || 0) - 72));
      };
      const setMenu = (isOpen) => {
        if (!menu || !openMenu) return;
        menu.hidden = !isOpen;
        openMenu.setAttribute('aria-expanded', String(isOpen));
        document.documentElement.style.overflow = isOpen ? 'hidden' : '';
      };
      syncHeader();
      window.addEventListener('scroll', syncHeader, { passive: true });
      openMenu?.addEventListener('click', () => setMenu(true));
      closeMenu?.addEventListener('click', () => setMenu(false));
      menu?.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => setMenu(false)));

      root.querySelectorAll('.jwa-series').forEach((seriesSection) => {
      const seriesTrack = seriesSection.querySelector('.jwa-series-grid');
      const seriesControls = seriesSection.querySelector('.jwa-series-controls');
      if (seriesTrack && seriesControls) {
        const previous = seriesControls.querySelector('[data-series-prev]');
        const next = seriesControls.querySelector('[data-series-next]');
        const syncSeries = () => {
          const max = seriesTrack.scrollWidth - seriesTrack.clientWidth;
          seriesControls.hidden = max <= 2;
          previous.disabled = seriesTrack.scrollLeft <= 2;
          next.disabled = seriesTrack.scrollLeft >= max - 2;
        };
        const moveSeries = (direction) => {
          const card = seriesTrack.querySelector('.jwa-series-card');
          const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(seriesTrack).columnGap);
          seriesTrack.scrollBy({left: direction * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        };
        previous.addEventListener('click', () => moveSeries(-1));
        next.addEventListener('click', () => moveSeries(1));
        seriesTrack.addEventListener('scroll', syncSeries, {passive:true});
        seriesTrack.addEventListener('keydown', (event) => {
          if (event.target !== seriesTrack || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          moveSeries(event.key === 'ArrowRight' ? 1 : -1);
        });
        const seriesObserver = new ResizeObserver(syncSeries);
        seriesObserver.observe(seriesTrack);
        document.addEventListener('shopify:section:unload', (event) => {
          if (event.target.contains(root)) seriesObserver.disconnect();
        });
        syncSeries();
      }
      });

      if (!stage || !cards.length) return;
      const mobileHint = 'Glissez · Touchez pour agrandir';
      const resetHint = () => { if (hint) hint.textContent = finePointer ? root.dataset.hintBrowse : mobileHint; };
      if (!finePointer) {
        if (intro) intro.textContent = 'Faites glisser les œuvres. Touchez-en une pour l’agrandir, puis une seconde fois pour la découvrir.';
        resetHint();
      }
      const activate = (card, pointer) => {
        active = card;
        const activeIndex = card ? cards.indexOf(card) : -1;
        stage.classList.toggle('has-active', Boolean(card));
        cards.forEach((item, index) => {
          item.classList.toggle('is-active', item === card);
          if (!card) {
            item.style.setProperty('--jwa-push-x', '0px');
            item.style.setProperty('--jwa-push-y', '0px');
            item.style.setProperty('--jwa-tilt-x', '0deg');
            item.style.setProperty('--jwa-tilt-y', '0deg');
          } else if (item === card) {
            const rect = item.getBoundingClientRect();
            const dx = pointer ? (pointer.x - (rect.left + rect.width / 2)) / Math.max(rect.width, 1) : 0;
            const dy = pointer ? (pointer.y - (rect.top + rect.height / 2)) / Math.max(rect.height, 1) : 0;
            item.style.setProperty('--jwa-push-x', `${Math.max(-9, Math.min(9, dx * 9))}px`);
            item.style.setProperty('--jwa-push-y', `${Math.max(-22, Math.min(-12, -18 + dy * 5))}px`);
            item.style.setProperty('--jwa-tilt-x', `${Math.max(-5, Math.min(5, -dy * 5))}deg`);
            item.style.setProperty('--jwa-tilt-y', `${Math.max(-6, Math.min(6, dx * 6))}deg`);
          } else {
            const distance = Math.abs(index - activeIndex);
            const direction = index < activeIndex ? -1 : 1;
            item.style.setProperty('--jwa-push-x', `${direction * Math.max(30, 96 - (distance - 1) * 11)}px`);
            item.style.setProperty('--jwa-push-y', '0px');
            item.style.setProperty('--jwa-tilt-x', '0deg');
            item.style.setProperty('--jwa-tilt-y', '0deg');
          }
        });
      };
      if (finePointer) {
        cards.forEach((card) => {
          card.addEventListener('focus', () => activate(card));
          card.addEventListener('blur', () => activate(null));
        });
        stage.addEventListener('pointermove', (event) => {
          const card = event.target.closest('.jwa-art-card[href]');
          activate(card, card ? { x: event.clientX, y: event.clientY } : null);
        });
        stage.addEventListener('pointerleave', () => activate(null));
      } else {
        stage.addEventListener('pointerdown', (event) => {
          pointerStart = { x: event.clientX, y: event.clientY };
        }, { passive: true });
        stage.addEventListener('pointercancel', () => { pointerStart = null; }, { passive: true });
        stage.addEventListener('click', (event) => event.preventDefault());
        stage.addEventListener('pointerup', (event) => {
          const card = event.target.closest('.jwa-art-card[href]');
          if (!card) { activate(null); return; }
          const moved = pointerStart ? Math.hypot(event.clientX - pointerStart.x, event.clientY - pointerStart.y) : 0;
          pointerStart = null;
          if (moved > 10) {
            activate(null);
            resetHint();
            return;
          }
          if (active === card) { window.location.assign(card.href); return; }
          activate(card);
          card.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
          if (hint) hint.textContent = root.dataset.hintOpen;
        });
      }
    };

    const boot = (scope = document) => {
      if (scope.matches?.('.jwa-studio')) init(scope);
      scope.querySelectorAll('.jwa-studio').forEach(init);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(), { once: true });
    else boot();
    document.addEventListener('shopify:section:load', (event) => boot(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
